import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { renderDuration } from '@/utils/renderDuration';
import { SxProps, Theme } from '@mui/system';

const Container = styled(Stack)(({ theme }) => ({
  background: theme.palette.blue4,
  padding: '4px 4px 4px 16px;',
}));

interface TransitDividerProps {
  duration: number;
  airportName: string;
  sx?: SxProps<Theme>
}

const TransitDivider: React.FC<TransitDividerProps> = ({
  airportName,
  duration,
  sx,
}) => (
  <Container
    sx={sx}
    direction="row"
    spacing="0.5rem"
    alignItems="center"
    borderRadius="12px"
    padding="5px 16px"
  >
    <img
      src="/images/transit-icon.png"
      alt="transit-icon"
      width="18px"
    />
    <Typography
      variant="contentRegular"
    >
      Quá cảnh khoảng
      {' '}
      <strong>{renderDuration(duration)}</strong>
      {' '}
      tại
      {' '}
      {airportName}
    </Typography>
  </Container>
);

export default TransitDivider;
